import { z } from 'zod'

export const LISTING_ACTION_MAX_LENGTH = 120
/** An action runs at most this many calendar days, today included. */
export const LISTING_ACTION_MAX_DAYS = 7
export const LISTING_ACTION_RECENT_LIMIT = 10

export const listingActionTextSchema = z.string().trim().min(1).max(LISTING_ACTION_MAX_LENGTH)

export const createListingActionRequestSchema = z.object({
  text: listingActionTextSchema,
  endsAt: z.iso.datetime(),
})
export type CreateListingActionRequest = z.infer<typeof createListingActionRequestSchema>

export const listingActionDtoSchema = z.object({
  id: z.string().uuid(),
  text: z.string(),
  startsAt: z.iso.datetime(),
  endsAt: z.iso.datetime(),
  endedAt: z.iso.datetime().nullable(),
  /** When the push went out; null while it waits for the morning or after it was dropped. */
  pushedAt: z.iso.datetime().nullable(),
  recipientCount: z.number().int().nonnegative().nullable(),
  /** The Vienna day the action was sent on (YYYY-MM-DD). */
  localDate: z.iso.date(),
})
export type ListingActionDto = z.infer<typeof listingActionDtoSchema>

export const activeListingActionSchema = z.object({
  id: z.string().uuid(),
  text: z.string(),
  endsAt: z.iso.datetime(),
})
export type ActiveListingAction = z.infer<typeof activeListingActionSchema>

export const listingActionsResponseSchema = z.object({
  /** Followers with the bell on. */
  favoriteCount: z.number().int().nonnegative(),
  /** The action sent today (Vienna), running or not. */
  today: listingActionDtoSchema.nullable(),
  /** The action showing right now, sent today or on an earlier day. */
  running: listingActionDtoSchema.nullable(),
  recent: z.array(listingActionDtoSchema),
})
export type ListingActionsResponse = z.infer<typeof listingActionsResponseSchema>

export const listingActionCardDtoSchema = z.object({
  id: z.string().uuid(),
  listingId: z.string().uuid(),
  listingName: z.string(),
  coverImageUrl: z.string().nullable(),
  text: z.string(),
  endsAt: z.iso.datetime(),
})
export type ListingActionCardDto = z.infer<typeof listingActionCardDtoSchema>
